export const setBoldTextParts = (text: string, highlightChar = '*') => {
  const regex = new RegExp(`\\${highlightChar}(.*?)\\${highlightChar}`, 'g')

  return text.replace(regex, '<strong>$1</strong>')
}
